import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { KonuService} from '../ctl-konu.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: KonuService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity,['CmyKonu','GenBirim','GenKullanici']);
            dataSource.select(['Kod','CmyKonu.Ad','GenBirim.Ad','GenKullanici.Adi','GenKullanici.Soyadi']);

            const filterArr = [];
            if(this.service.birimKod) filterArr.push(['BirimKod', '<>', this.service.birimKod]);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }

}
